<template>
  <div class="comp-page">
    <!-- ============ 品牌头部 ============ -->
    <header class="sub-header">
      <div class="sub-header-inner">
        <button type="button" class="back-btn" aria-label="返回" @click="goBack">
          <van-icon name="arrow-left" />
        </button>
        <h1 class="sub-title">合规自查表</h1>
      </div>
    </header>

    <main class="page-content">
      <!-- 导语 -->
      <p class="page-lead">本自查表分为七大部分，覆盖贸易业务关键环节，供企业内部对照自查、留档备查使用。</p>

      <!-- 七大模块 -->
      <section class="surface-section part-section">
        <header class="section-heading">
          <h2>自查七大模块</h2>
          <span></span>
        </header>
        <ol class="part-list">
          <li v-for="item in parts" :key="item.no">
            <span class="part-no">{{ item.no }}</span>
            <div class="part-body">
              <h3>{{ item.name }}</h3>
            </div>
          </li>
        </ol>
      </section>

      <!-- 唯一主操作 -->
      <div class="action-area">
        <button type="button" class="primary-action" @click="downloadExcel">
          下载EXCEL表格<van-icon name="arrow" />
        </button>
      </div>
    </main>
  </div>
</template>

<script>
import { CHECK_EXCEL_URL, downloadFile } from '../utils/download'
import guoqiShare from '../utils/guoqiShare'
import pageAccess, { reportDownload } from '../utils/pageAccess'
export default {
  name: 'guoqiComp',
  mixins: [guoqiShare, pageAccess],
  data () {
    return {
      // 页面访问日志：页面名称
      pageName: '合规自查表',
      // 微信分享：链接为当前路由
      shareTitle: '国企贸易合规自查表：七大板块自查要点',
      shareDesc: '主责主业、商业合理性、采购销售、仓储物流、结算资金、内控体系全流程自查',
      parts: [
        { no: '一', name: '主责主业' },
        { no: '二', name: '商业合理性与业务真实性' },
        { no: '三', name: '采购管理' },
        { no: '四', name: '销售管理' },
        { no: '五', name: '仓储与物流管理' },
        { no: '六', name: '结算与资金管理' },
        { no: '七', name: '内控体系与责任追究' }
      ]
    }
  },
  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/guoqi')
      }
    },
    // 合规自查表 Excel：真实文件下载
    downloadExcel () {
      downloadFile(CHECK_EXCEL_URL, '自查表.xlsx')
      reportDownload({
        openId: this.$cookies.get('openId'),
        pageName: this.pageName,
        filename: '自查表.xlsx',
        url: CHECK_EXCEL_URL
      })
      this.$toast.success('已开始下载')
    }
  }
}
</script>

<style lang="less" scoped>
@page-bg: #faf7f1;
@surface: #fffdfc;
@ink: #142033;
@body: #333a45;
@muted: #7f858d;
@brand: #ef4f16;
@brand-light: #f47a3c;
@brand-soft: #fff1e8;
@gold: #d7a34a;
@line: #e9e6e1;

button { margin: 0; padding: 0; border: 0; color: inherit; font: inherit; background: transparent; appearance: none; }
ol { margin: 0; padding: 0; list-style: none; }

.comp-page { min-height: 100vh; box-sizing: border-box; color: @ink; background: @page-bg; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; }

/* ================= 品牌头部 ================= */
.sub-header { position: sticky; top: 0; z-index: 20; background: rgba(250, 247, 241, 0.94); backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px); border-bottom: 1px solid @line; }
.sub-header-inner { position: relative; display: flex; align-items: center; max-width: 750px; height: 88px; margin: 0 auto; padding: 0 24px; box-sizing: border-box; }
.back-btn { display: inline-flex; align-items: center; justify-content: center; width: 60px; height: 60px; color: @ink; cursor: pointer; }
.back-btn .van-icon { font-size: 38px; }
.sub-title { position: absolute; right: 24px; left: 24px; margin: 0; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 34px; font-weight: 700; letter-spacing: 1px; line-height: 88px; text-align: center; pointer-events: none; }

/* ================= 页面主体 ================= */
.page-content { max-width: 750px; margin: 0 auto; padding: 30px 0 56px; }

.page-lead { margin: 0; padding: 0 40px; color: @body; font-size: 24px; line-height: 1.7; }

/* ================= 编辑式区块标题 ================= */
.section-heading {
  display: flex;
  align-items: center;
  h2 { margin: 0; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 35px; font-weight: 700; line-height: 1; }
  span { width: 34px; height: 5px; margin-left: 18px; border-radius: 3px; background: @brand; }
}

/* ================= 自查七大模块 ================= */
.part-section { margin-top: 26px; padding: 34px 40px 6px; background: @surface; }

.part-list { margin-top: 18px; }
.part-list li { position: relative; display: flex; align-items: flex-start; padding: 26px 0; }
.part-list li::after { position: absolute; right: 0; bottom: 0; left: 0; height: 1px; background: @line; content: ""; }
.part-list li:last-child::after { display: none; }

.part-no { flex: 0 0 74px; padding-top: 1px; color: @brand; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 40px; font-weight: 700; line-height: 1.1; text-align: center; }
.part-body { flex: 1; min-width: 0; padding-left: 24px; border-left: 2px solid @line; }
.part-list li:first-child .part-body { border-left-color: @brand; }
.part-body h3 { margin: 0; color: @ink; font-size: 29px; font-weight: 700; line-height: 1.4; }

/* ================= 主操作 ================= */
.action-area { padding: 44px 40px 0; text-align: center; }
.primary-action { display: inline-flex; align-items: center; justify-content: center; gap: 12px; box-sizing: border-box; width: 100%; height: 66px; margin: 0 auto; padding: 0 30px; color: #fff; font-size: 28px; font-weight: 600; border-radius: 33px; background: linear-gradient(90deg, @brand, @brand-light); box-shadow: 0 9px 20px rgba(239, 79, 22, 0.2); cursor: pointer; }
.primary-action .van-icon { font-size: 26px; }
.action-tip { margin: 18px 0 0; color: @muted; font-size: 20px; }

@media (max-width: 420px) {
  .sub-header-inner { height: 78px; padding: 0 14px; }
  .sub-title { right: 14px; left: 14px; font-size: 30px; line-height: 78px; }
  .page-content { padding: 24px 0 40px; }
  .page-lead { padding: 0 22px; font-size: 21px; }
  .part-section { padding: 26px 22px 4px; }
  .part-no { flex-basis: 58px; font-size: 34px; }
  .part-body { padding-left: 18px; }
  .part-body h3 { font-size: 25px; }
  .action-area { padding: 34px 22px 0; }
  .primary-action { height: 58px; font-size: 25px; border-radius: 29px; }
  .action-tip { font-size: 17px; }
}
</style>
